var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('img',{staticClass:"logo vivantial",attrs:{"src":require("../assets/vivantial_logo.png")}}),_c('img',{staticClass:"logo helloteca",attrs:{"src":require("../assets/logo_color.png")}})])
}]

export { render, staticRenderFns }